import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default__default, { useState, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../../node_modules/@flixbus/honeycomb/dist/scss/components/data-table.scss.js';
import HoneyBem from '../../../../packages/honey-bem/honey-bem.js';
import { CellContent, SelectionInputProps } from '../../data-table-prop-types.js';
import Checkbox from '../../../checkbox/checkbox.js';
import { Icon } from '../../../../node_modules/@flixbus/honeycomb-icons-react/dist/esm/components/icon/icon.js';
import { IconArrowBigDown } from '../../../../node_modules/@flixbus/honeycomb-icons-react/dist/esm/components/icons/inline/icon-arrow-big-down.js';
import { IconArrowBigUp } from '../../../../node_modules/@flixbus/honeycomb-icons-react/dist/esm/components/icons/inline/icon-arrow-big-up.js';
import { IconExpand } from '../../../../node_modules/@flixbus/honeycomb-icons-react/dist/esm/components/icons/inline/icon-expand.js';
import { Injecss } from '../../../../packages/injecss/injecss.js';

const dataTableBem = HoneyBem.init('data-table', styles);
const DataTableHeader = _ref => {
  let {
    headers,
    selectAllProps,
    isSelected,
    sortingPropsList
  } = _ref;
  const [selected, setSelected] = useState(isSelected);
  const [sorting, setSorting] = useState({});
  useEffect(() => {
    setSelected(isSelected);
  }, [isSelected]);

  /**
   * calls back selectAllProps.onChange with current input status and updates component state
   * @param {InputEvent} event - event object
   */
  const handleChange = event => {
    if (selectAllProps.onChange) {
      selectAllProps.onChange({
        value: selectAllProps.value,
        selected: event.target.checked
      });
    }
    setSelected(event.target.checked);
  };

  /**
   * calls back sorting function with new table sorting order and updates component state
   * @param {Object} sortingProps - an item from the sortingPropsList
   */
  const handleSorting = sortingProps => {
    /** if sorted column is the same: toggle order; if not: reset it to true */
    const newSorting = sortingProps.columnIndex === sorting.columnIndex ? !sorting.ascendingOrder : true;
    const newOrder = {
      columnIndex: sortingProps.columnIndex,
      ascendingOrder: newSorting
    };
    sortingProps.sortingFunction(newOrder);
    setSorting(newOrder);
  };

  /**
   * Returns the set of sorting props for a given column index
   * @param {number} columnIndex - the column index
   */
  const findSortingPropsForColumnIndex = columnIndex => sortingPropsList ? sortingPropsList.find(currentProps => currentProps.columnIndex === columnIndex) : null;
  const getOrderDependentProps = sortingProps => {
    if (sorting.columnIndex === sortingProps.columnIndex) {
      /** If is ascending order returns asc label and arrow down icon */
      if (sorting.ascendingOrder) {
        return {
          icon: IconArrowBigDown,
          label: sortingProps.labelAsc
        };
      }

      /** If is descending order returns desc label and arrow up icon */
      return {
        icon: IconArrowBigUp,
        label: sortingProps.labelDesc
      };
    }

    /** If not ordered, then return default label and expand icon */
    return {
      icon: IconExpand,
      label: sortingProps.label
    };
  };
  return /*#__PURE__*/React__default__default.createElement("thead", {
    className: dataTableBem.e('header')
  }, /*#__PURE__*/React__default__default.createElement("tr", null, selectAllProps && /*#__PURE__*/React__default__default.createElement("th", {
    scope: "col"
  }, /*#__PURE__*/React__default__default.createElement(Checkbox, _extends({}, selectAllProps, {
    checked: selected,
    onChange: handleChange,
    small: true
  }))), headers.map((header, index) => {
    const sortingProps = findSortingPropsForColumnIndex(index);
    if (sortingProps) {
      const orderDependentProps = getOrderDependentProps(sortingProps);
      return /*#__PURE__*/React__default__default.createElement("th", {
        scope: "col",
        key: index
      }, header, /*#__PURE__*/React__default__default.createElement("button", {
        className: dataTableBem.e('header-btn'),
        type: "button",
        "aria-label": orderDependentProps.label,
        onClick: () => {
          handleSorting(sortingProps);
        }
      }, /*#__PURE__*/React__default__default.createElement(Icon, {
        InlineIcon: orderDependentProps.icon,
        "aria-hidden": "true"
      })));
    }
    return /*#__PURE__*/React__default__default.createElement("th", {
      scope: "col",
      key: index
    }, header);
  })));
};
DataTableHeader.displayName = 'DataTableHeader';
DataTableHeader.defaultProps = {
  selectAllProps: null,
  isSelected: false,
  sortingPropsList: null
};
DataTableHeader.propTypes = {
  /** List of table headers: [`string`|`node`|`number`] */
  headers: CellContent.isRequired,
  /** Displays a checkbox to select all data-table rows */
  selectAllProps: SelectionInputProps,
  /** Sets row's selected state */
  isSelected: PropTypes__default.bool,
  /** Optional list of properties for sorting rows with a given column index */
  sortingPropsList: PropTypes__default.arrayOf(PropTypes__default.shape({
    columnIndex: PropTypes__default.number.isRequired,
    label: PropTypes__default.string.isRequired,
    labelAsc: PropTypes__default.string.isRequired,
    labelDesc: PropTypes__default.string.isRequired,
    sortingFunction: PropTypes__default.func.isRequired
  }))
};
var DataTableHeader$1 = Injecss(DataTableHeader, styles);

export { DataTableHeader$1 as default };
